export interface CreateOrderFormModel {
	form?: string;
	file?: File | null;
	organization?: string;
	schema?: string;
	referenceId?: string;
	engagementFile?: File | null;
	product?: string;
}

export class OrganizationModel {
	id: string;
	name: string;
}

export interface FormModel {
	form: string;
	schema: string;
	displayText: string;
}

export const enum PRIME_DIALOG_RESULT {
	SUCCESS,
	ERROR,
	CLOSE,
}

export const CREATE_MANUAL_ORDER = 'create-manual-order'


